import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab } from '@material-ui/core'





export default class BugetAssign extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    style={{ zIndex: 6000 }}
                >
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose}
                            className="pm-round-button-dialog"
                            style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
                        >
                            <i style={{ color: 'black', fontSize: 28, fontWeight: 500 }} className='material-icons'>close</i>
                        </Fab>
                    </DialogActions>
                    <h2 className='pm-dialog-alert-title'>{this.props.title}</h2>

                    <DialogContent>
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            tableLayout: 'auto',
                            textAlign: 'left'
                        }}>
                            <thead>
                                <tr style={{ borderBottom: '1px solid gray', fontSize: 12, lineHeight: '34px' }}>
                                    <th></th>
                                    <th>Nume Buget</th>
                                    <th>Valoare Buget</th>


                                </tr>
                            </thead>
                            <tbody>
                                {this.props.bugete.map((b, idx) => {
                                    return (
                                        <tr key={idx}>
                                            <td style={{
                                                padding: '20px 20px 0 0',
                                                textSlign: 'left'
                                            }}> <i onClick={() => { this.props.selecteazaBuget(b) }} style={{
                                                verticalAlign: 'middle',
                                                marginRight: 10,
                                                fontSize: 20,
                                                cursor: 'pointer',
                                                color: b.id_cheltuiala === this.props.cheltuialaSelectata.id ? 'green' : 'gray'
                                            }} className='material-icons'>check_circle_outline</i>
                                            </td>
                                            <td style={{
                                                padding: '20px 20px 0 0',
                                                textSlign: 'left'
                                            }}>{b.nume}</td>
                                            <td style={{
                                                padding: '20px 20px 0 0',
                                                textSlign: 'left'
                                            }}>{b.valoare}</td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </DialogContent>
                    <DialogActions className="pm-dialog-bottom-buttons">



                        <Button style={{ display: 'inline-block', padding: '10px 20px 10px 20px', backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={this.props.dialogClose}   >

                            Salveaza
                          </Button>




                    </DialogActions>


                </Dialog>
            </div>
        );
    }
}